export function insertAt(array, index, ...elements) {
    array.splice(index, 0, ...elements);
}

export const chunkArray = (array, size) => {
    if (size <= 0) {
        throw new Error('Chunk size must be a positive number');
    }

    return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => array.slice(i * size, i * size + size));
};
